export const getRandomValue = (num: number) => Math.floor(Math.random() * num);

type FortuneDetail = {
  wish: string | string[];
  business: string | string[];
  health: string | string[];
};

type FortuneType = {
  fortune: string;
  image: string;
  probability: number;
  detail: FortuneDetail;
};

export type ResultType = FortuneType & {
  checkList?: string;
  fortuneCount?: number;
};

export const defaultFortune: FortuneType = {
  fortune: '',
  image: '',
  probability: 0,
  detail: { wish: '', business: '', health: '' },
};

export const fortuneData: FortuneType[] = [
  {
    fortune: '大吉',
    image: '/images/omikuji_daikichi.png',
    probability: 1,
    detail: {
      wish: [
        '願い事が予想外の形で叶う好機',
        '目標達成への情熱が開運の星となる好機',
        '絶好の機会が訪れている、躊躇なく望むところへ進め',
        '思い切った行動が大成功へ導く',
        '強く願えば全て叶う',
      ],
      business: [
        '商売運芳しく、新規取引先を開拓できそうな気配',
        'ライバル企業の失敗により好機の兆し',
        '新商品に運が味方しそう。認知度アップへ',
        'あなたの活躍により大規模プロジェクトがスムーズに推移していく予感',
        '意外なところからビジネスチャンスが訪れる可能性大',
      ],
      health: [
        '気力・体力共に充実してくる好機',
        '食事バランスを意識して健康増進が狙える時期',
        '適度な運動で運気UPにつながる好機到来',
        '気分転換が体力回復に良い影響が期待できる',
        '筋力トレーニングによる効果大',
      ],
    },
  },
  {
    fortune: '吉',
    image: '/images/omikuji_kichi.png',
    probability: 99,
    detail: {
      wish: [
        'これまでの実績が新たな展開への布石へ',
        '思い切った決断の度胸が大きく運を呼ぶ',
        '身の回りに幸運の兆し、行動力が求められる',
        '浮ついた発想が思わぬ開花の契機に',
        '過去の教訓が活きてパワーアップできる可能性',
      ],
      business: [
        '商売敵現るるも我に利あり',
        '商機逸すること莫れ。果敢にチャンスをつかめ',
        '収益UPで資金繰り好転の兆し。投資の好機到来',
        '宣伝効果絶大で売上好調が期待できる',
        '遠回りながら着実に実力を付け、業界をリードできる運気',
      ],
      health: [
        '栄養バランスを考えた食事と適度な運動が体力UPにつながる',
        '心身のバランスを保つコツは睡眠時間をしっかり確保すること',
        '睡眠時間をしっかり確保することが体調管理の近道',
        '良好な生活リズムが体調面でも好循環生む',
        '健やかに過ごせる。過度の運動で、ケガに注意',
      ],
    },
  },
  {
    fortune: '中吉',
    image: '/images/omikuji_chuukichi.png',
    probability: 150,
    detail: {
      wish: [
        '時期的にも決断の場到来。要冷静判断',
        '地道な努力が大きな成果のタネとなる',
        '周囲の思惑外れる展開、独自路線の果敢さも大事',
        'これまでの努力が徐々に実を結び始める兆し',
        '持てる力を遺憾なく発揮するチャンス到来',
      ],
      business: [
        '手堅い経営を心がければ好決算が期待できる',
        '業績が思わぬ方面で伸びしろを見せ始めている',
        '仕事面での運気はやや不調、体調に影響をきたす前に休め',
        '思いも寄らない土地柄からビジネスヒントを得る気配',
        '少しずつではあるが商圏を拡大できる素地ができつつある',
      ],
      health: [
        '食欲旺盛な一方で体重は思うように増えない体質',
        'ダイエットに対する意欲は高いが効果がでにくい',
        '目の疲れが気になる時期。健康診断で要チェックを',
        'アレルギー症状に気をつけたほうが良さそう',
        '肩こり・腰痛など筋肉系の症状に注意が必要な時期',
      ],
    },
  },
  {
    fortune: '小吉',
    image: '/images/omikuji_syoukichi.png',
    probability: 350,
    detail: {
      wish: [
        '現状打破の契機は直感にあり、冷静な判断が必要',
        '時流に合わせ切り替えも重要な判断材料',
        '過去の不遇時代が遠のき始める。少しずつ幸運が訪れる予感',
        '願いを叶えるヒントが身近なところから得られる可能性',
        '幸運なひらめきに恵まれながら実現できそう',
      ],
      business: [
        '大型案件を受注できそうな息吹感じる',
        '意外なブレイクスルーが事業拡大につながりそう',
        '商売繁盛の兆し！取引先も増え、フル稼働間近',
        '新規事業立ち上げで苦労するが後に大きく実を結ぶ運気',
        '地道な営業努力が実ってくる兆しを感じる',
      ],
      health: [
        'からだに支障がでない範囲で適度な運動を',
        '気だるさが取れずに嫌気が差す時期。気分転換を図って',
        'ストレス性の体調不良が出やすい。リラックスできる工夫を',
        '慢性的な疲労蓄積に注意。無理せず体調管理',
        '食べ過ぎに注意。栄養バランスが大切',
      ],
    },
  },

  {
    fortune: '末吉',
    image: '/images/omikuji_suekichi.png',
    probability: 500,
    detail: {
      wish: [
        '当面の目標達成へ追い風が吹き始めた予兆あり',
        '何事も前向きに取り組む心意気が運気アップにつながる',
        '時流や周囲の変化も味方する。无難な方法で実現を',
        '遠回りをしても迂闊な行動を起こさなければ着実に前進できる',
        '情熱・執念が徐々に形となって結実する兆し',
      ],
      business: [
        '業績低迷の原因を特定できる好機到来',
        '事業拡大のビジョンが浮かび上がってくる予感',
        '業績低迷の兆候。新商品投入の検討を',
        '欲張ることなく手堅い営業を選べば成果が実る兆し',
        '合併など大きな変革につながりそうな出来事があるかも？',
      ],
      health: [
        '体調上下が激しく体力を消耗しがちな時期',
        '免疫力低下で風邪をひきやすい体質。防御力UPが大事',
        '何となく体調を崩しやすい時期。健康管理に注意を',
        '運動好きの性格が災いして怪我をしがちな時期',
        '急激な減量は体調崩しやすい。ゆるやかに改善を',
      ],
    },
  },
  {
    fortune: '凶',
    image: '/images/omikuji_kyou.png',
    probability: 900,
    detail: {
      wish: [
        '周囲を巻き込みながら計画的に目標を達成していくことが大切',
        'ひらめきを大切にしつつ地道な努力が大事',
        '控えめな姿勢を保ちつつ好機を見極めよ',
        '潮時を見極め大局的に判断することが大切',
        '過去の栄光に縋らず、今を見据えて精進せよ',
      ],
      business: [
        '新サービス立ち上げに運気滅頂。波瀾の予感',
        '商売運わるく、競合他社に水をあけられる',
        '知人の紹介で意外な商機に巡り会えそうな予感',
        '小さな投資が後に大きな利益につながりそうな予感',
        '過剰に営業が拡大し、組織に混乱を招く',
      ],
      health: [
        '食いしん坊な性格が高じて太りやすい時期。気をつけて',
        'ストレスからくる慢性的な疲労に悩まされがち',
        '筋肉痛など体の諸症状が出始める予感。要チェック',
        '食事と運動のバランスが崩れやすく体型変化に繋がりがち',
        '不定愁訴に悩まされがちな時期',
      ],
    },
  },
  {
    fortune: '大凶',
    image: '/images/omikuji_daikyou.png',
    probability: 8000,
    detail: {
      wish: [
        'なにをしても叶わぬ、耐えろ',
        '一意専心で挑めば、望みあり',
        '願うのみならず、行動せよ',
        '真に求め、精進すれば吉兆が訪れる',
        '焦らず、好機まで耐えしのぐべし',
      ],
      business: [
        '利益少し焦るな、後になれば益あり',
        '少し向こう見ずだ、休むことも重要',
        '落ち着き、堅実さを取り戻せ',
        '損あり、待ち耐え抜くべし',
        '利あらず、焦るな',
      ],
      health: [
        '不規則な生活が体調不良を招きやすい気配。自己管理大事',
        '行動的な性格からくる肉体疲労に注意。無理は禁物',
        '流行病にかかりやすい時期、気をつけよ',
        '気分や体調の波が大きい時期。無理は禁物',
        '絶不調、休め',
      ],
    },
  },
];

export const checkList = [
  'リリース当日のアサインに漏れはありませんか？',
  '要件・仕様は全て盛り込まれていますか？',
  'リリース対象のファイルの準備は順調ですか？',
  '必要の無いコードを残していませんか？',
  'メンテナンスを考慮したコードになっていますか？',
  'システムパフォーマンスはクリアできていますか？',
  'データのバックアップ/リストア方法は万全ですか？',
  'テスト結果に漏れはありませんでしたか？',
  '無影響確認は実施できていますか？',
  'セキュリティー診断に不備はありませんか？',
  'リリース作業には余裕を持った時間を確保していますか？',
  'リリース作業関係者に、当日の作業内容は共有できていますか？',
  'もし万が一の覚悟はできていますか？',
];
